module.exports = __webpack_public_path__ + "img/4.d9ffb0c7.png";